import { createStore, applyMiddleware, compose } from "redux";
import multi from "redux-multi";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import promise from "redux-promise";
import thunk from "redux-thunk";

import rootReducer from "../reducers/index";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["note", "layout", "form", "toastr", "socket"]
  // whitelist: ['user','language','general']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk, promise, multi))
);
const persistor = persistStore(store);

export { store, persistor };
